import React from 'react'

export const SportsbookCheckbox = ({ id = '', label, ...props }) => {
  return (
    <>
      <div className='flexContainer'>
        <label id={id} className='checkboxOption'>
          <input {...props} type='checkbox' />
          <span className='checkmark' />
        </label>
        <div className='labelContent'>{label}</div>
      </div>
      <style jsx>{`
        .flexContainer {
          display: flex;
          align-items: top;
          margin-bottom: 12px;
          min-height: 32px;
        }
        label {
          color: #010101;
          font-family: 'IBM Plex Sans Condensed';
          font-size: 16px;
          letter-spacing: 0;
          font-weight: 100;
          margin: 0;
          cursor: pointer;
        }
        .labelContent {
          color: #010101;
          font-family: 'IBM Plex Sans Condensed';
          font-size: 16px;
          letter-spacing: 0;
          font-weight: 100;
        }
        .checkboxOption {
          position: relative;
          display: block;
          text-align: left;
          align-items: center;
          padding-left: 30px;
          width: 0;
        }
        .checkboxOption input {
          position: absolute;
          opacity: 0;
          cursor: pointer;
          height: 0;
          width: 0;
        }
        .checkboxOption input:checked ~ .checkmark {
          background-color: #1555d0;
          box-shadow: 0;
          border: 0;
        }
        .checkboxOption input:checked ~ .checkmark:after {
          display: block;
        }
        .checkboxOption .checkmark:after {
          left: 0.3rem;
          top: 0.2rem;
          width: 0.2rem;
          height: 0.4rem;
          border: solid white;
          border-width: 0 3px 3px 0;
          -webkit-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          transform: rotate(45deg);
        }
        .checkmark {
          position: absolute;
          top: 0;
          left: 0;
          height: 16px;
          width: 16px;
          background-color: #fff;
          border: 1px solid #e7e8e8;
          border-radius: 2px;
          box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12),
            0 1px 3px 0 rgba(0, 0, 0, 0.2);
        }
        .checkmark:after {
          content: '';
          position: absolute;
          display: none;
        }
      `}</style>
    </>
  )
}
